import { AlertTriangle } from "lucide-react";
import EmptyState from "./EmptyState";

type TableErrorProps = {
  message?: string;
  title?: string;
};

const TableError = ({
  message = "Data kunne ikke indlæses lige nu.",
  title = "Der opstod en fejl",
}: TableErrorProps) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center p-3"
      role="alert"
    >
      <EmptyState
        icon={<AlertTriangle size={24} strokeWidth={1.75} />}
        title={title}
        description={message}
        variant="danger"
      />
    </div>
  );
};

export default TableError;
